import React from "react"

import { Heading } from "~/components/Heading/Heading"

import { VideoFrame } from "./components/VideoFrame/VideoFrame"
import styles from "./index.module.css"

type GalleryProps = {
  src: string
  title: string
}

export const Video: React.FC<GalleryProps> = ({ src, title }) => {
  return (
    <div className={styles.Wrapper}>
      <VideoFrame className={styles.VideoFrame} src={src} />

      <div className={styles.Description}>
        <Heading className={styles.Title} like="h3">
          {title}
        </Heading>
      </div>
    </div>
  )
}
